export default __webpack_public_path__ + "static/media/Avocado.a47677c6.mp4";